module.exports = __webpack_public_path__ + "assets/images/igg1.0efffc16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/return/igg1.png
// module id = 383
// module chunks = 1